import { render } from "./RouteCustomization.vue?vue&type=template&id=c331a922&scoped=true"
import script from "./RouteCustomization.vue?vue&type=script&lang=js"
export * from "./RouteCustomization.vue?vue&type=script&lang=js"

import "./RouteCustomization.vue?vue&type=style&index=0&id=c331a922&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c331a922"]])

export default __exports__